import { render, staticRenderFns } from "./SearchListMobile.vue?vue&type=template&id=135cbb9c&scoped=true&"
import script from "./SearchListMobile.vue?vue&type=script&lang=ts&"
export * from "./SearchListMobile.vue?vue&type=script&lang=ts&"
import style0 from "./SearchListMobile.vue?vue&type=style&index=0&id=135cbb9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135cbb9c",
  null
  
)

export default component.exports